export default __webpack_public_path__ + "static/media/horizon_line_guide_v2.6d0d8cc6.jpg";